module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "marketstudies-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "fileId": _vm.appraisalfile.id,
        "fileNumber": _vm.appraisalfile.number,
        "reportOpen": _vm.reportOpen,
        "reportNumber": _vm.appraisalreport.number,
        "versionNumber": _vm.appraisalreport.version,
        "realEstates": _vm.appraisalreport_realestates,
        "realEstateId": _vm.realestate.id,
        "reportId": _vm.appraisalreport.id
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Market_study_for')) + " "), (_vm.realestate.street_name) ? _c('span', [_vm._v(_vm._s(_vm.realestate.street_name))]) : _vm._e(), (_vm.realestate.street_number) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.street_number))]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e(), _vm._v(" "), (_vm.marketstudy.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.marketstudy.market_value && _vm.marketstudy.market_unit_value) ? _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('Market_value')) + ": " + _vm._s(_vm._f("formatNumber")(_vm.marketstudy.market_value)) + " €  (" + _vm._s(_vm._f("formatNumber")(_vm.marketstudy.market_unit_value)) + " €/m²)")])]) : _vm._e(), _vm._v(" "), (_vm.marketstudy.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.marketstudy.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.marketstudy.date_modified)))])]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.marketstudy_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container",
      staticStyle: {
        "background-color": "#fafafc",
        "padding": "2rem"
      }
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Real_estate_referral')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticStyle: {
        "padding-left": "1.5rem"
      }
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Address')))]), _vm._v(" "), _c('strong', [_c('span', [_vm._v(_vm._s(_vm.realestate.street_name))]), (_vm.realestate.street_number) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.street_number))]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e(), (_vm.realestate.postal_code) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.postal_code))]) : _vm._e(), (_vm.realestate.municipality) ? _c('span', [_vm._v(" - " + _vm._s(_vm.realestate.municipality.name_ine))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticStyle: {
        "padding-left": "1.5rem"
      }
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cadastral_reference')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.realestate.cadastral_reference))])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onOpenCadastralMap($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onOpenCadastralMap($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "external-link",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Open')) + " " + _vm._s(_vm.$t('Cadastral_Map')))], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Property_type')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.appraisal_property_typeValue,
        "options": _vm.property_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": false,
        "selectedLabel": "",
        "selectLabel": "",
        "deselectLabel": ""
      },
      on: {
        "input": _vm.set_appraisal_property_type
      },
      model: {
        value: (_vm.appraisal.property_type),
        callback: function($$v) {
          _vm.appraisal.property_type = $$v
        },
        expression: "appraisal.property_type"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Built_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.adopted_area),
        expression: "appraisal.adopted_area"
      }],
      staticClass: "field__group__input",
      staticStyle: {
        "background-color": "white!important"
      },
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.adopted_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.adopted_area = $event.target.value
        }, _vm.set_appraisal_adopted_area_event],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Construction_year')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.construction_year),
        expression: "appraisal.construction_year"
      }],
      staticClass: "field__group__input",
      staticStyle: {
        "background-color": "white!important"
      },
      attrs: {
        "type": "number",
        "maxlength": "4",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.construction_year)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.construction_year = $event.target.value
        }, _vm.set_appraisal_construction_year_event],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Last_renovation_year')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.last_renovation_year),
        expression: "appraisal.last_renovation_year"
      }],
      staticClass: "field__group__input",
      staticStyle: {
        "background-color": "white!important"
      },
      attrs: {
        "type": "number",
        "maxlength": "4",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.last_renovation_year)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.last_renovation_year = $event.target.value
        }, _vm.set_appraisal_last_renovation_year_event],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Adopted_age')) + " (" + _vm._s(_vm.$t('Average')) + ")")]), _vm._v(" "), _c('strong', [_c('span', [_vm._v(_vm._s(_vm.appraisal.adopted_age))])])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Floor_number')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.floor_number),
        expression: "appraisal.floor_number"
      }],
      staticClass: "field__group__input",
      staticStyle: {
        "background-color": "white!important"
      },
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.floor_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.floor_number = $event.target.value
        }, _vm.set_appraisal_floor_number_event],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quality_of_neighbourhood')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.appraisal_quality_of_neighbourhoodValue,
        "options": _vm.quality_of_neighbourhoodOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": false,
        "selectedLabel": "",
        "selectLabel": "",
        "deselectLabel": ""
      },
      on: {
        "input": _vm.set_appraisal_quality_of_neighbourhood
      },
      model: {
        value: (_vm.appraisal.quality_of_neighbourhood),
        callback: function($$v) {
          _vm.appraisal.quality_of_neighbourhood = $$v
        },
        expression: "appraisal.quality_of_neighbourhood"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quality_of_situation')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.appraisal_quality_of_situationValue,
        "options": _vm.quality_of_situationOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": false,
        "selectedLabel": "",
        "selectLabel": "",
        "deselectLabel": ""
      },
      on: {
        "input": _vm.set_appraisal_quality_of_situation
      },
      model: {
        value: (_vm.appraisal.quality_of_situation),
        callback: function($$v) {
          _vm.appraisal.quality_of_situation = $$v
        },
        expression: "appraisal.quality_of_situation"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quality_of_construction')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.appraisal_quality_of_constructionValue,
        "options": _vm.quality_of_constructionOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": false,
        "selectedLabel": "",
        "selectLabel": "",
        "deselectLabel": ""
      },
      on: {
        "input": _vm.set_appraisal_quality_of_construction
      },
      model: {
        value: (_vm.appraisal.quality_of_construction),
        callback: function($$v) {
          _vm.appraisal.quality_of_construction = $$v
        },
        expression: "appraisal.quality_of_construction"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quality_of_realestate')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.appraisal_quality_of_realestateValue,
        "options": _vm.quality_of_realestateOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": false,
        "selectedLabel": "",
        "selectLabel": "",
        "deselectLabel": ""
      },
      on: {
        "input": _vm.set_appraisal_quality_of_realestate
      },
      model: {
        value: (_vm.appraisal.quality_of_realestate),
        callback: function($$v) {
          _vm.appraisal.quality_of_realestate = $$v
        },
        expression: "appraisal.quality_of_realestate"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Conservation_status')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.appraisal_conservation_statusValue,
        "options": _vm.conservation_statusOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": false,
        "selectedLabel": "",
        "selectLabel": "",
        "deselectLabel": ""
      },
      on: {
        "input": _vm.set_appraisal_conservation_status
      },
      model: {
        value: (_vm.appraisal.conservation_status),
        callback: function($$v) {
          _vm.appraisal.conservation_status = $$v
        },
        expression: "appraisal.conservation_status"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Lift')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.lift),
        expression: "appraisal.lift"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.lift) ? _vm._i(_vm.appraisal.lift, null) > -1 : (_vm.appraisal.lift)
      },
      on: {
        "click": _vm.set_appraisal_lift_event,
        "__c": function($event) {
          var $$a = _vm.appraisal.lift,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.lift = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.lift = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.lift = $$c
          }
        }
      }
    })])]), _vm._v(" "), (!this.appraisal.property_type) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.property_type_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!this.appraisal.adopted_area) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.adopted_area_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!this.appraisal.adopted_age) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.adopted_age_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _c('div', [(this.appraisal.adopted_age.toString().length < 4) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.adopted_age_length_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : (this.appraisal.adopted_age.toString().length > 4) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.adopted_age_length_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "section-container",
      staticStyle: {
        "background-color": "#fafafc",
        "padding": "2rem"
      }
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Ad_database_query')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Comparable_type')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.queryAdTypeValue,
        "options": _vm.queryAdTypeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ?
          'name_ca' : (_vm.currentLocale === 'en') ?
          'name_en' : 'name_es',
        "searchable": false
      },
      on: {
        "input": _vm.set_marketstudy_query_ad_type
      },
      model: {
        value: (_vm.marketstudy.query_ad_type),
        callback: function($$v) {
          _vm.marketstudy.query_ad_type = $$v
        },
        expression: "marketstudy.query_ad_type"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Advertisements_between_starting_date')) + ":")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.marketstudy.query_startdate),
        expression: "marketstudy.query_startdate"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "date",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.marketstudy.query_startdate)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.marketstudy.query_startdate = $event.target.value
        }, _vm.set_marketstudy_query_startdate]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('and_limit_date')) + ":")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.marketstudy.query_limitdate),
        expression: "marketstudy.query_limitdate"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "date",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.marketstudy.query_limitdate)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.marketstudy.query_limitdate = $event.target.value
        }, _vm.set_marketstudy_query_limitdate]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Search_radius_km')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.marketstudy.query_distance_km),
        expression: "marketstudy.query_distance_km"
      }],
      staticClass: "field__group__input",
      staticStyle: {
        "background-color": "white!important"
      },
      attrs: {
        "type": "number",
        "min": "0",
        "step": "any",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.marketstudy.query_distance_km)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.marketstudy.query_distance_km = $event.target.value
        }, _vm.set_marketstudy_query_distance_km],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [(this.realestate.lat && this.realestate.lng && this.marketstudy.query_startdate && this.marketstudy.query_limitdate && this.marketstudy.query_ad_type && this.appraisal.property_type && this.appraisal.adopted_area && this.appraisal.adopted_age) ? _c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onQueryAds($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onQueryAds($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "globe",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Query_comparables')))], 1)])]) : _vm._e(), _vm._v(" "), (_vm.query_comparables_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + "...")], 1)]) : _vm._e()]), _vm._v(" "), (!this.realestate.lat && !this.realestate.lng) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.lat_lng_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!this.marketstudy.query_startdate || !this.marketstudy.query_limitdate) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.query_date_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!this.marketstudy.query_ad_type) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.query_ad_type_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Query_result')))]), _vm._v(" "), _c('div', {
      staticClass: "query_table"
    }, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-main",
        "source": _vm.marketstudy_matched_ads,
        "filterable": false,
        "striped": _vm.ad_table.striped,
        "editable": _vm.ad_table.editable,
        "line-numbers": _vm.ad_table.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "property_type",
        fn: function(cell) {
          return [(cell.row['property_type']) ? _c('div', [(_vm.currentLocale === 'ca') ? _c('span', [_vm._v(_vm._s(cell.row['property_type'].name_ca))]) : (_vm.currentLocale === 'es') ? _c('span', [_vm._v(_vm._s(cell.row['property_type'].name_es))]) : (_vm.currentLocale === 'en') ? _c('span', [_vm._v(_vm._s(cell.row['property_type'].name_en))]) : _vm._e()]) : _vm._e()]
        }
      }, {
        key: "conservation_status",
        fn: function(cell) {
          return [(cell.row['conservation_status']) ? _c('div', [(_vm.currentLocale === 'ca') ? _c('span', [_vm._v(_vm._s(cell.row['conservation_status'].name_ca))]) : (_vm.currentLocale === 'es') ? _c('span', [_vm._v(_vm._s(cell.row['conservation_status'].name_es))]) : (_vm.currentLocale === 'en') ? _c('span', [_vm._v(_vm._s(cell.row['conservation_status'].name_en))]) : _vm._e()]) : _vm._e()]
        }
      }, {
        key: "actions-matched_ads",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.openlink_text
            },
            on: {
              "click": function($event) {
                _vm.openAdLink(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "link",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.choose_text
            },
            on: {
              "click": function($event) {
                _vm.chooseAd(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "plus",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.discard_text
            },
            on: {
              "click": function($event) {
                _vm.discardAd(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "times",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }])
    }, [_c('datatable-column', {
      attrs: {
        "id": "actions-matched_ads",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _vm._l((_vm.ad_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    })], 2)], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container",
      staticStyle: {
        "background-color": "#fafafc",
        "padding": "2rem"
      }
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Import_comparable_set_from_another_market_study')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('File_number')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.importAppraisalFileValue,
        "options": _vm.object_to_array(_vm.appraisalfiles),
        "track-by": "id",
        "label": 'number',
        "searchable": true
      },
      on: {
        "input": _vm.set_import_appraisalfile
      },
      model: {
        value: (_vm.marketstudy.importAppraisalFile),
        callback: function($$v) {
          _vm.marketstudy.importAppraisalFile = $$v
        },
        expression: "marketstudy.importAppraisalFile"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [(_vm.marketstudy.importAppraisalFile) ? _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Report')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.importReportValue,
        "options": _vm.object_to_array(_vm.temp_appraisalreports),
        "track-by": "id",
        "label": 'number',
        "searchable": true
      },
      on: {
        "input": _vm.set_import_report
      },
      model: {
        value: (_vm.marketstudy.importReport),
        callback: function($$v) {
          _vm.marketstudy.importReport = $$v
        },
        expression: "marketstudy.importReport"
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [(_vm.marketstudy.importReport) ? _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Real_estate')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.importRealEstateValue,
        "options": _vm.object_to_array(_vm.temp_realestates),
        "track-by": "id",
        "label": 'street_name',
        "searchable": true
      },
      on: {
        "input": _vm.set_import_realestate
      },
      model: {
        value: (_vm.marketstudy.importRealEstate),
        callback: function($$v) {
          _vm.marketstudy.importRealEstate = $$v
        },
        expression: "marketstudy.importRealEstate"
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [(_vm.marketstudy.importRealEstate) ? _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Market_study')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.importMarketStudyValue,
        "options": _vm.object_to_array(_vm.temp_marketstudies),
        "track-by": "id",
        "label": 'id',
        "searchable": true
      },
      on: {
        "input": function($event) {}
      },
      model: {
        value: (_vm.marketstudy.importMarketStudy),
        callback: function($$v) {
          _vm.marketstudy.importMarketStudy = $$v
        },
        expression: "marketstudy.importMarketStudy"
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [(_vm.marketstudy.importRealEstate) ? _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onImportComparableSet({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-down",
        "text": _vm.import_comparable_set_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Selected_comparables')))]), _vm._v(" "), _c('div', {
      staticClass: "query_table"
    }, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-selected_comparables",
        "source": _vm.object_to_array(_vm.marketstudy_ad_comparables),
        "filterable": false,
        "striped": _vm.comparable_table.striped,
        "editable": _vm.comparable_table.editable,
        "line-numbers": _vm.comparable_table.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "property_type",
        fn: function(cell) {
          return [(cell.row['property_type']) ? _c('div', [(_vm.currentLocale === 'ca') ? _c('span', [_vm._v(_vm._s(cell.row['property_type'].name_ca))]) : (_vm.currentLocale === 'es') ? _c('span', [_vm._v(_vm._s(cell.row['property_type'].name_es))]) : (_vm.currentLocale === 'en') ? _c('span', [_vm._v(_vm._s(cell.row['property_type'].name_en))]) : _vm._e()]) : _vm._e()]
        }
      }, {
        key: "conservation_status",
        fn: function(cell) {
          return [(cell.row['conservation_status']) ? _c('div', [(_vm.currentLocale === 'ca') ? _c('span', [_vm._v(_vm._s(cell.row['conservation_status'].name_ca))]) : (_vm.currentLocale === 'es') ? _c('span', [_vm._v(_vm._s(cell.row['conservation_status'].name_es))]) : (_vm.currentLocale === 'en') ? _c('span', [_vm._v(_vm._s(cell.row['conservation_status'].name_en))]) : _vm._e()]) : _vm._e()]
        }
      }, {
        key: "actions-selected_comparables",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.openlink_text
            },
            on: {
              "click": function($event) {
                _vm.openAdLink(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "link",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editAd(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteAdComparable(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }])
    }, [_c('datatable-column', {
      attrs: {
        "id": "actions-selected_comparables",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _vm._l((_vm.comparable_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    })], 2)], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Data_tabulation')))]), _vm._v(" "), _c('div', {
      staticClass: "weighing_table"
    }, [_c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-tabulation",
        "source": _vm.object_to_array(_vm.marketstudy_ad_comparables),
        "filterable": false,
        "striped": _vm.tabulation_table.striped,
        "editable": _vm.tabulation_table.editable,
        "line-numbers": _vm.tabulation_table.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "property_type",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.property_typeValue,
              "options": _vm.property_typeOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": function($event) {
                _vm.set_entity_property_type($event, cell.row)
              }
            },
            model: {
              value: (cell.row['property_type']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'property_type';
                if (!Array.isArray($$exp)) {
                  cell.row['property_type'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['property_type']"
            }
          })], 1)]
        }
      }, {
        key: "quality_of_neighbourhood",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.quality_of_neighbourhoodValue,
              "options": _vm.quality_of_neighbourhoodOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": function($event) {
                _vm.set_entity_quality_of_neighbourhood($event, cell.row)
              }
            },
            model: {
              value: (cell.row['quality_of_neighbourhood']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'quality_of_neighbourhood';
                if (!Array.isArray($$exp)) {
                  cell.row['quality_of_neighbourhood'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['quality_of_neighbourhood']"
            }
          })], 1)]
        }
      }, {
        key: "quality_of_situation",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.quality_of_situationValue,
              "options": _vm.quality_of_situationOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": function($event) {
                _vm.set_entity_quality_of_situation($event, cell.row)
              }
            },
            model: {
              value: (cell.row['quality_of_situation']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'quality_of_situation';
                if (!Array.isArray($$exp)) {
                  cell.row['quality_of_situation'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['quality_of_situation']"
            }
          })], 1)]
        }
      }, {
        key: "quality_of_construction",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.quality_of_constructionValue,
              "options": _vm.quality_of_constructionOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": function($event) {
                _vm.set_entity_quality_of_construction($event, cell.row)
              }
            },
            model: {
              value: (cell.row['quality_of_construction']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'quality_of_construction';
                if (!Array.isArray($$exp)) {
                  cell.row['quality_of_construction'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['quality_of_construction']"
            }
          })], 1)]
        }
      }, {
        key: "quality_of_realestate",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.quality_of_realestateValue,
              "options": _vm.quality_of_realestateOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": function($event) {
                _vm.set_entity_quality_of_realestate($event, cell.row)
              }
            },
            model: {
              value: (cell.row['quality_of_realestate']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'quality_of_realestate';
                if (!Array.isArray($$exp)) {
                  cell.row['quality_of_realestate'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['quality_of_realestate']"
            }
          })], 1)]
        }
      }, {
        key: "conservation_status",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.conservation_statusValue,
              "options": _vm.conservation_statusOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": function($event) {
                _vm.set_entity_conservation_status($event, cell.row)
              }
            },
            model: {
              value: (cell.row['conservation_status']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'conservation_status';
                if (!Array.isArray($$exp)) {
                  cell.row['conservation_status'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['conservation_status']"
            }
          })], 1)]
        }
      }, {
        key: "adopted_age",
        fn: function(cell) {
          return [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['adopted_age']),
              expression: "cell.row['adopted_age']"
            }],
            attrs: {
              "type": "number",
              "maxlength": "4"
            },
            domProps: {
              "value": (cell.row['adopted_age'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'adopted_age';
                if (!Array.isArray($$exp)) {
                  cell.row['adopted_age'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_entity_adopted_age($event, cell.row)
              }],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])]
        }
      }, {
        key: "adopted_area",
        fn: function(cell) {
          return [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['adopted_area']),
              expression: "cell.row['adopted_area']"
            }],
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['adopted_area'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'adopted_area';
                if (!Array.isArray($$exp)) {
                  cell.row['adopted_area'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_entity_adopted_area($event, cell.row)
              }],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])]
        }
      }, {
        key: "floor_number",
        fn: function(cell) {
          return [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['floor_number']),
              expression: "cell.row['floor_number']"
            }],
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['floor_number'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'floor_number';
                if (!Array.isArray($$exp)) {
                  cell.row['floor_number'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_entity_floor_number($event, cell.row)
              }],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])]
        }
      }, {
        key: "lift",
        fn: function(cell) {
          return [_c('div', [_c('checkbox', {
            attrs: {
              "id": cell.row.id,
              "editable": _vm.editabletrue
            },
            on: {
              "toggle_flag": function($event) {
                _vm.set_entity_lift(cell.row['lift'], cell.row)
              }
            },
            model: {
              value: (cell.row['lift']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'lift';
                if (!Array.isArray($$exp)) {
                  cell.row['lift'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['lift']"
            }
          })], 1)]
        }
      }])
    }, _vm._l((_vm.tabulation_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }))], 1)])]), _vm._v(" "), _c('div', {}, [_c('span', [_vm._v(_vm._s(_vm.$t('Appraised')) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-appraisal_tabulation",
        "source": _vm.appraisal_tabulation,
        "filterable": false,
        "striped": _vm.appraisal_tabulation_table.striped,
        "editable": _vm.appraisal_tabulation_table.editable,
        "line-numbers": _vm.appraisal_tabulation_table.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "property_type",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.appraisal_property_typeValue,
              "options": _vm.property_typeOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": _vm.set_appraisal_property_type
            },
            model: {
              value: (cell.row['property_type']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'property_type';
                if (!Array.isArray($$exp)) {
                  cell.row['property_type'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['property_type']"
            }
          })], 1)]
        }
      }, {
        key: "conservation_status",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.appraisal_conservation_statusValue,
              "options": _vm.conservation_statusOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": _vm.set_appraisal_conservation_status
            },
            model: {
              value: (cell.row['conservation_status']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'conservation_status';
                if (!Array.isArray($$exp)) {
                  cell.row['conservation_status'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['conservation_status']"
            }
          })], 1)]
        }
      }, {
        key: "quality_of_neighbourhood",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.appraisal_quality_of_neighbourhoodValue,
              "options": _vm.quality_of_neighbourhoodOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": _vm.set_appraisal_quality_of_neighbourhood
            },
            model: {
              value: (cell.row['quality_of_neighbourhood']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'quality_of_neighbourhood';
                if (!Array.isArray($$exp)) {
                  cell.row['quality_of_neighbourhood'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['quality_of_neighbourhood']"
            }
          })], 1)]
        }
      }, {
        key: "quality_of_situation",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.appraisal_quality_of_situationValue,
              "options": _vm.quality_of_situationOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": _vm.set_appraisal_quality_of_situation
            },
            model: {
              value: (cell.row['quality_of_situation']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'quality_of_situation';
                if (!Array.isArray($$exp)) {
                  cell.row['quality_of_situation'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['quality_of_situation']"
            }
          })], 1)]
        }
      }, {
        key: "quality_of_construction",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.appraisal_quality_of_constructionValue,
              "options": _vm.quality_of_constructionOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": _vm.set_appraisal_quality_of_construction
            },
            model: {
              value: (cell.row['quality_of_construction']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'quality_of_construction';
                if (!Array.isArray($$exp)) {
                  cell.row['quality_of_construction'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['quality_of_construction']"
            }
          })], 1)]
        }
      }, {
        key: "quality_of_realestate",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.appraisal_quality_of_realestateValue,
              "options": _vm.quality_of_realestateOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": _vm.set_appraisal_quality_of_realestate
            },
            model: {
              value: (cell.row['quality_of_realestate']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'quality_of_realestate';
                if (!Array.isArray($$exp)) {
                  cell.row['quality_of_realestate'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['quality_of_realestate']"
            }
          })], 1)]
        }
      }, {
        key: "adopted_age",
        fn: function(cell) {
          return [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['adopted_age']),
              expression: "cell.row['adopted_age']"
            }],
            attrs: {
              "type": "number",
              "maxlength": "4"
            },
            domProps: {
              "value": (cell.row['adopted_age'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'adopted_age';
                if (!Array.isArray($$exp)) {
                  cell.row['adopted_age'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_appraisal_adopted_age(cell.row['adopted_age'])
              }],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])]
        }
      }, {
        key: "adopted_area",
        fn: function(cell) {
          return [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['adopted_area']),
              expression: "cell.row['adopted_area']"
            }],
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['adopted_area'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'adopted_area';
                if (!Array.isArray($$exp)) {
                  cell.row['adopted_area'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_appraisal_adopted_area(cell.row['adopted_area'])
              }],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])]
        }
      }, {
        key: "floor_number",
        fn: function(cell) {
          return [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['floor_number']),
              expression: "cell.row['floor_number']"
            }],
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['floor_number'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'floor_number';
                if (!Array.isArray($$exp)) {
                  cell.row['floor_number'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_appraisal_floor_number(cell.row['floor_number'])
              }],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])]
        }
      }, {
        key: "lift",
        fn: function(cell) {
          return [_c('div', [_c('checkbox', {
            attrs: {
              "id": cell.row.id,
              "editable": _vm.editabletrue
            },
            on: {
              "toggle_flag": function($event) {
                _vm.set_appraisal_lift(cell.row['lift'])
              }
            },
            model: {
              value: (cell.row['lift']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'lift';
                if (!Array.isArray($$exp)) {
                  cell.row['lift'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['lift']"
            }
          })], 1)]
        }
      }])
    }, _vm._l((_vm.appraisal_tabulation_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter,
          "showHeader": column.showHeader
        }
      })
    }))], 1)])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Qualities_comparison')))]), _vm._v(" "), _c('div', {
      staticClass: "query_table"
    }, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-comparison",
        "source": _vm.object_to_array(_vm.marketstudy_ad_comparables),
        "filterable": false,
        "striped": _vm.comparison_table.striped,
        "editable": _vm.comparison_table.editable,
        "line-numbers": _vm.comparison_table.lineNumbers
      }
    }, _vm._l((_vm.comparison_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }))], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Homogenisation_of_values')))]), _vm._v(" "), _c('div', {
      staticClass: "weighing_table"
    }, [_c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-weighing",
        "source": _vm.object_to_array(_vm.weighing),
        "filterable": false,
        "striped": _vm.weighing_table.striped,
        "editable": _vm.weighing_table.editable,
        "line-numbers": _vm.weighing_table.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "ad_date",
        fn: function(cell) {
          return [_c('div', {
            staticStyle: {
              "text-align": "center",
              "margin": "0 auto"
            }
          }, [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['ad_date']),
              expression: "cell.row['ad_date']"
            }],
            staticClass: "weighing-input",
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['ad_date'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'ad_date';
                if (!Array.isArray($$exp)) {
                  cell.row['ad_date'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, _vm.set_marketstudy_weighing_ad_date],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])])]
        }
      }, {
        key: "property_type",
        fn: function(cell) {
          return [_c('div', {
            staticStyle: {
              "text-align": "center",
              "margin": "0 auto"
            }
          }, [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['property_type']),
              expression: "cell.row['property_type']"
            }],
            staticClass: "weighing-input",
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['property_type'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'property_type';
                if (!Array.isArray($$exp)) {
                  cell.row['property_type'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, _vm.set_marketstudy_weighing_property_type],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])])]
        }
      }, {
        key: "quality_of_neighbourhood",
        fn: function(cell) {
          return [_c('div', {
            staticStyle: {
              "text-align": "center",
              "margin": "0 auto"
            }
          }, [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['quality_of_neighbourhood']),
              expression: "cell.row['quality_of_neighbourhood']"
            }],
            staticClass: "weighing-input",
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['quality_of_neighbourhood'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'quality_of_neighbourhood';
                if (!Array.isArray($$exp)) {
                  cell.row['quality_of_neighbourhood'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, _vm.set_marketstudy_weighing_quality_of_neighbourhood],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])])]
        }
      }, {
        key: "quality_of_situation",
        fn: function(cell) {
          return [_c('div', {
            staticStyle: {
              "text-align": "center",
              "margin": "0 auto"
            }
          }, [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['quality_of_situation']),
              expression: "cell.row['quality_of_situation']"
            }],
            staticClass: "weighing-input",
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['quality_of_situation'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'quality_of_situation';
                if (!Array.isArray($$exp)) {
                  cell.row['quality_of_situation'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, _vm.set_marketstudy_weighing_quality_of_situation],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])])]
        }
      }, {
        key: "quality_of_construction",
        fn: function(cell) {
          return [_c('div', {
            staticStyle: {
              "text-align": "center",
              "margin": "0 auto"
            }
          }, [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['quality_of_construction']),
              expression: "cell.row['quality_of_construction']"
            }],
            staticClass: "weighing-input",
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['quality_of_construction'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'quality_of_construction';
                if (!Array.isArray($$exp)) {
                  cell.row['quality_of_construction'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, _vm.set_marketstudy_weighing_quality_of_construction],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])])]
        }
      }, {
        key: "quality_of_realestate",
        fn: function(cell) {
          return [_c('div', {
            staticStyle: {
              "text-align": "center",
              "margin": "0 auto"
            }
          }, [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['quality_of_realestate']),
              expression: "cell.row['quality_of_realestate']"
            }],
            staticClass: "weighing-input",
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['quality_of_realestate'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'quality_of_realestate';
                if (!Array.isArray($$exp)) {
                  cell.row['quality_of_realestate'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, _vm.set_marketstudy_weighing_quality_of_realestate],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])])]
        }
      }, {
        key: "adopted_age",
        fn: function(cell) {
          return [_c('div', {
            staticStyle: {
              "text-align": "center",
              "margin": "0 auto"
            }
          }, [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['adopted_age']),
              expression: "cell.row['adopted_age']"
            }],
            staticClass: "weighing-input",
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['adopted_age'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'adopted_age';
                if (!Array.isArray($$exp)) {
                  cell.row['adopted_age'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, _vm.set_marketstudy_weighing_adopted_age],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])])]
        }
      }, {
        key: "conservation_status",
        fn: function(cell) {
          return [_c('div', {
            staticStyle: {
              "text-align": "center",
              "margin": "0 auto"
            }
          }, [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['conservation_status']),
              expression: "cell.row['conservation_status']"
            }],
            staticClass: "weighing-input",
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['conservation_status'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'conservation_status';
                if (!Array.isArray($$exp)) {
                  cell.row['conservation_status'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, _vm.set_marketstudy_weighing_conservation_status],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])])]
        }
      }, {
        key: "floor_number",
        fn: function(cell) {
          return [_c('div', {
            staticStyle: {
              "text-align": "center",
              "margin": "0 auto"
            }
          }, [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['floor_number']),
              expression: "cell.row['floor_number']"
            }],
            staticClass: "weighing-input",
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['floor_number'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'floor_number';
                if (!Array.isArray($$exp)) {
                  cell.row['floor_number'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, _vm.set_marketstudy_weighing_floor_number],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])])]
        }
      }, {
        key: "adopted_area",
        fn: function(cell) {
          return [_c('div', {
            staticStyle: {
              "text-align": "center",
              "margin": "0 auto"
            }
          }, [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['adopted_area']),
              expression: "cell.row['adopted_area']"
            }],
            staticClass: "weighing-input",
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['adopted_area'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'adopted_area';
                if (!Array.isArray($$exp)) {
                  cell.row['adopted_area'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, _vm.set_marketstudy_weighing_adopted_area],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])])]
        }
      }, {
        key: "lift",
        fn: function(cell) {
          return [_c('div', {
            staticStyle: {
              "text-align": "center",
              "margin": "0 auto"
            }
          }, [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['lift']),
              expression: "cell.row['lift']"
            }],
            staticClass: "weighing-input",
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['lift'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'lift';
                if (!Array.isArray($$exp)) {
                  cell.row['lift'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, _vm.set_marketstudy_weighing_lift],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])])]
        }
      }])
    }, _vm._l((_vm.weighing_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter,
          "showHeader": column.showHeader
        }
      })
    }))], 1)])]), _vm._v(" "), _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-homogenisation",
        "source": _vm.object_to_array(_vm.marketstudy_ad_comparables),
        "filterable": false,
        "striped": _vm.homogenisation_table.striped,
        "editable": _vm.homogenisation_table.editable,
        "line-numbers": _vm.homogenisation_table.lineNumbers
      }
    }, _vm._l((_vm.homogenisation_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter,
          "showHeader": column.showHeader
        }
      })
    }))], 1)])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Correction_of_values')))]), _vm._v(" "), _c('div', {
      staticClass: "query_table"
    }, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-correction",
        "source": _vm.object_to_array(_vm.marketstudy_ad_comparables),
        "filterable": false,
        "striped": _vm.correction_table.striped,
        "editable": _vm.correction_table.editable,
        "line-numbers": _vm.correction_table.lineNumbers
      }
    }, _vm._l((_vm.correction_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }))], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Regression_line_calculation')))]), _vm._v(" "), _c('div', {
      staticClass: "query_table"
    }, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-regressioncalc",
        "source": _vm.object_to_array(_vm.marketstudy_ad_comparables),
        "filterable": false,
        "striped": _vm.regressioncalc_table.striped,
        "editable": _vm.regressioncalc_table.editable,
        "line-numbers": _vm.regressioncalc_table.lineNumbers
      }
    }, _vm._l((_vm.regressioncalc_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }))], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Typical_deviation')) + ", " + _vm._s(_vm.$t('universal_sample')))]), _vm._v(" "), _c('div', {
      staticClass: "query_table"
    }, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-univdev",
        "source": _vm.object_to_array(_vm.universal_sample_typical_deviation),
        "filterable": false,
        "striped": _vm.univ_dev_table.striped,
        "editable": _vm.univ_dev_table.editable,
        "line-numbers": _vm.univ_dev_table.lineNumbers
      }
    }, _vm._l((_vm.univ_dev_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }))], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Typical_deviation')) + ", " + _vm._s(_vm.$t('representative_sample')))]), _vm._v(" "), _c('div', {
      staticClass: "query_table"
    }, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-reprdev",
        "source": _vm.object_to_array(_vm.representative_sample_typical_deviation),
        "filterable": false,
        "striped": _vm.repr_dev_table.striped,
        "editable": _vm.repr_dev_table.editable,
        "line-numbers": _vm.repr_dev_table.lineNumbers
      }
    }, _vm._l((_vm.repr_dev_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }))], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('div', {
      attrs: {
        "id": "regline"
      }
    }, [_c('vue-chart', {
      attrs: {
        "chart-type": _vm.regressionline_chart.chartType,
        "columns": _vm.regressionline_chart.columns,
        "rows": _vm.regressionline_chart.rows,
        "options": _vm.regressionline_chart.options
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Market_value_of_the_appraised_realestate')))]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Built_area')) + ": " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.adopted_area)) + " m²"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('Market_value')) + ": " + _vm._s(_vm._f("formatNumber")(_vm.marketstudy.market_value)) + " €"), _c('br')]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('Market_unit_value')) + ": " + _vm._s(_vm._f("formatNumber")(_vm.marketstudy.market_unit_value)) + " €/m²"), _c('br')])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Market_analysis')))])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Offer')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Offer_production')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.offer_productionValue,
        "options": _vm.quality_levelOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_marketstudy_offer_production
      },
      model: {
        value: (_vm.marketstudy.offer_production),
        callback: function($$v) {
          _vm.marketstudy.offer_production = $$v
        },
        expression: "marketstudy.offer_production"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Offer_yearly_stock')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.offer_yearly_stockValue,
        "options": _vm.quality_level_mascOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_marketstudy_offer_yearly_stock
      },
      model: {
        value: (_vm.marketstudy.offer_yearly_stock),
        callback: function($$v) {
          _vm.marketstudy.offer_yearly_stock = $$v
        },
        expression: "marketstudy.offer_yearly_stock"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Offer_trend')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.offer_trendValue,
        "options": _vm.trendOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_marketstudy_offer_trend
      },
      model: {
        value: (_vm.marketstudy.offer_trend),
        callback: function($$v) {
          _vm.marketstudy.offer_trend = $$v
        },
        expression: "marketstudy.offer_trend"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Demand')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Demand_level')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.demand_levelValue,
        "options": _vm.quality_levelOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_marketstudy_demand_level
      },
      model: {
        value: (_vm.marketstudy.demand_level),
        callback: function($$v) {
          _vm.marketstudy.demand_level = $$v
        },
        expression: "marketstudy.demand_level"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Demand_speed_of_sales')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.demand_speed_of_salesValue,
        "options": _vm.termOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_marketstudy_demand_speed_of_sales
      },
      model: {
        value: (_vm.marketstudy.demand_speed_of_sales),
        callback: function($$v) {
          _vm.marketstudy.demand_speed_of_sales = $$v
        },
        expression: "marketstudy.demand_speed_of_sales"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Demand_trend')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.demand_trendValue,
        "options": _vm.trendOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_marketstudy_demand_trend
      },
      model: {
        value: (_vm.marketstudy.demand_trend),
        callback: function($$v) {
          _vm.marketstudy.demand_trend = $$v
        },
        expression: "marketstudy.demand_trend"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Prices')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Maximum')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.marketstudy.prices_max)) + " €/m²")])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Average')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.marketstudy.prices_mean)) + " €/m²")])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Median')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.marketstudy.prices_median)) + " €/m²")])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Minimum')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.marketstudy.prices_min)) + " €/m²")])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Prices_estimated_yearly_evolution_pct')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.marketstudy.prices_estimated_yearly_evolution_pct),
        expression: "marketstudy.prices_estimated_yearly_evolution_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.marketstudy.prices_estimated_yearly_evolution_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.marketstudy.prices_estimated_yearly_evolution_pct = $event.target.value
        }, _vm.set_marketstudy_prices_estimated_yearly_evolution_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Prices_expectancy')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.prices_expectancyValue,
        "options": _vm.trendOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_marketstudy_prices_expectancy
      },
      model: {
        value: (_vm.marketstudy.prices_expectancy),
        callback: function($$v) {
          _vm.marketstudy.prices_expectancy = $$v
        },
        expression: "marketstudy.prices_expectancy"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Expectation')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Prices_past_cicles_volatility')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.prices_past_cicles_volatilityValue,
        "options": _vm.volatility_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_marketstudy_prices_past_cicles_volatility
      },
      model: {
        value: (_vm.marketstudy.prices_past_cicles_volatility),
        callback: function($$v) {
          _vm.marketstudy.prices_past_cicles_volatility = $$v
        },
        expression: "marketstudy.prices_past_cicles_volatility"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Market_conjuncture')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.market_conjunctureValue,
        "options": _vm.conjunctureOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_marketstudy_market_conjuncture
      },
      model: {
        value: (_vm.marketstudy.market_conjuncture),
        callback: function($$v) {
          _vm.marketstudy.market_conjuncture = $$v
        },
        expression: "marketstudy.market_conjuncture"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Market_value_reduction_probability_expectancy')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.market_value_reduction_probability_expectancyValue,
        "options": _vm.quality_levelOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_marketstudy_market_value_reduction_probability_expectancy
      },
      model: {
        value: (_vm.marketstudy.market_value_reduction_probability_expectancy),
        callback: function($$v) {
          _vm.marketstudy.market_value_reduction_probability_expectancy = $$v
        },
        expression: "marketstudy.market_value_reduction_probability_expectancy"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Market_value_evolution_probability_pct')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.marketstudy.market_value_evolution_probability_pct),
        expression: "marketstudy.market_value_evolution_probability_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.marketstudy.market_value_evolution_probability_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.marketstudy.market_value_evolution_probability_pct = $event.target.value
        }, _vm.set_marketstudy_market_value_evolution_probability_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Description')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('MarketStudy_description')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.marketstudy.description),
        expression: "marketstudy.description"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.marketstudy.description)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.marketstudy.description = $event.target.value
        }, _vm.set_marketstudy_description]
      }
    })])])])])])])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.set_entities_comparison_and_homogenisation($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "calculator",
        "text": _vm.calc_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "level-up",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentMarketStudy({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentMarketStudy({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.marketstudy.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f4b46fd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/marketstudies/MarketStudyEditor.vue
// module id = 2134
// module chunks = 0